export default __webpack_public_path__ + "static/media/fireLady.c085a406.jpg";